import TeamItem from './TeamItem'

export default TeamItem;